export const resolveCategoryNames = (categories, allCategories) => {
  const titleById = Object.fromEntries(
    allCategories?.map(({ id, title }) => [id, title]) ?? []
  );

  return (categories ?? [])
    .map((category) => titleById[category.id])
    .filter(Boolean);
};

export const getPrimaryUrl = (entity) => entity?.links?.[0]?.url;
